function mixWithWhite(hex, ratio) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return hex;
    const mix = (c) => Math.round(parseInt(c, 16) * ratio + 255 * (1 - ratio));
    const r = mix(result[1]);
    const g = mix(result[2]);
    const b = mix(result[3]);
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

// 500 → color base (100%) — identificación del tipo de evento / dot
export const colorScale500 = (hex) => hex;
// 300 → 40% color + 60% white — estado selected
export const colorScale300 = (hex) => hex ? mixWithWhite(hex, 0.40) : null;
// 200 → 30% color + 70% white — estado hover
export const colorScale200 = (hex) => hex ? mixWithWhite(hex, 0.30) : null;
// 100 → 20% color + 80% white — estado default (fondo del evento)
export const colorScale100 = (hex) => hex ? mixWithWhite(hex, 0.20) : null;

export function applyEventColors(element, bgColor, borderColor) {
    const color100 = colorScale100(bgColor);
    const color200 = colorScale200(bgColor);
    const color300 = colorScale300(bgColor);
    element._eventColors = { color100, color200, color300 };
    element._isSelected = false;
    element.style.backgroundColor = color100;
    element.style.borderLeft = `4px solid ${borderColor}`;
    element.addEventListener('mouseenter', () => {
        if (!element._isSelected) element.style.backgroundColor = color200;
    });
    element.addEventListener('mouseleave', () => {
        if (!element._isSelected) element.style.backgroundColor = color100;
    });
}

export function setEventSelected(element, isSelected) {
    if (!element?._eventColors) return;
    element._isSelected = isSelected;
    element.style.backgroundColor = isSelected
        ? element._eventColors.color300
        : element._eventColors.color100;
}
